import { connect } from 'react-redux';
import Fair from './Fair';
import React from 'react';
import { toggleFilterable } from '../../../actions/table';
import {
    fetchFairPoints,
    fetchFairProducts,
    fetchFairSuppliers,
    fetchFairDynamicWeeksData,
    addFairDynamicWeekPromiseCreator,
} from '../../../actions/routines';
import * as qs from 'qs';
import history from '../../../history';
import FairService from '../../../services/api/Fair';
import { setFairProducts } from '../../../actions/fair';
import FairDynamicWeeksModalContainer from '../../FairDynamicWeeksModal/FairDynamicWeeksModalContainer';
import { bindActionCreators } from 'redux';
import bindPromiseCreators from 'redux-saga-routines/dist/bindPromiseCreators';
import { injectIntl } from 'react-intl';
import saveFile from '../../../services/fileSaver';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';

const QS_OPTIONS = { arrayFormat: 'brackets' };

class FairContainer extends React.Component {
    constructor(props) {
        super(props);

        const queryParams = qs.parse(history.location.search.slice(1));
        const selectedSupplierParam =
            queryParams.s_s_suppliers || queryParams.s_s_supplier;
        const selectedSuppliers =
            selectedSupplierParam && selectedSupplierParam !== 'all-suppliers'
                ? Array.isArray(selectedSupplierParam)
                    ? selectedSupplierParam
                    : [selectedSupplierParam]
                : [];

        const savedColumns = localStorage.getItem(
            'whatColumnsToShowForFairProducts'
        );
        const parsedColumns = savedColumns ? JSON.parse(savedColumns) : [];
        const photoPreference = parsedColumns.find(
            (column) => column.id === 'productPhoto'
        );

        this.state = {
            selectedSuppliers,
            // mylist '0' is 'Alle producten' (see getSelectedProductFilter), the
            // intended landing filter for a fresh /fair.
            selectedProductType:
                queryParams.mylist !== undefined ? queryParams.mylist : '0',
            searchTerm: queryParams.s_all || '',
            fairCartProducts: [],
            isDynamicWeeksModalOpen: false,
            loadingState: {},
            showProductPhoto:
                photoPreference && typeof photoPreference.show === 'boolean'
                    ? photoPreference.show
                    : true,
            selectedGroup: 0,
            prevCart: Boolean(queryParams.for_cart),
            prevPromotions: String(queryParams.with_promotions) === '1',
            isMailLoading: false,
        };
    }

    componentDidMount() {
        const { userDetails } = this.props;

        const queryParams = qs.parse(history.location.search.slice(1));
        queryParams.mylist = 0; //Force to fetch all suppliers
        this.props.fetchFairSuppliers(queryParams);
        this.props.fetchFairPoints();
        this.props.fetchFairDynamicWeeksData();

        if (userDetails && !userDetails.is_fair_active) {
            history.push('/dashboard');
        }
        FairService.getFairProductsList().then((response) =>
            this.setState({ fairCartProducts: response.data })
        );
        this.props.toggleFilterable();
        if (queryParams.for_cart) {
            delete queryParams.for_cart;
            delete queryParams.s_s_supplier;
            delete queryParams.s_s_suppliers;
            return history.push({
                pathname: '/fair',
                search: qs.stringify(
                    {
                        ...queryParams,
                        mylist: 0,
                    },
                    QS_OPTIONS
                ),
            });
        }
    }

    componentDidUpdate(prevProps) {
        const { userDetails } = this.props;

        if (userDetails && !userDetails.is_fair_active) {
            history.push('/dashboard');
        }
    }

    addProduct = async (week, productId, amount) => {
        const loadStateKey = `${productId}-${week}`;

        this.setState((prevState) => ({
            loadingState: { ...prevState.loadingState, [loadStateKey]: true },
        }));

        await FairService.addProduct(
            week,
            productId,
            amount === '' ? 0 : amount
        );

        await FairService.getFairProductsList().then((response) =>
            this.setState({ fairCartProducts: response.data })
        );

        const queryParams = qs.parse(history.location.search.slice(1));

        queryParams.mylist = this.state.selectedProductType;

        history.push({
            ...this.props.location,
            search: qs.stringify(queryParams, QS_OPTIONS),
        });
        this.props.fetchFairProducts(queryParams);

        this.setState((prevState) => ({
            loadingState: { ...prevState.loadingState, [loadStateKey]: false },
        }));
    };

    fetchData = (params) => {
        params.mylist = this.state.selectedProductType;

        this.props.fetchFairProducts(params);
    };

    getSelectedSuppliers = (selectedSuppliers) => {
        this.setState({ selectedSuppliers });

        const params = qs.parse(history.location.search.slice(1));
        params.page = '1';
        delete params.s_s_supplier;

        if (!selectedSuppliers.length) {
            delete params.s_s_suppliers;
        } else {
            params.s_s_suppliers = selectedSuppliers;
        }

        history.push({
            ...this.props.location,
            search: qs.stringify(params, QS_OPTIONS),
        });

        this.props.fetchFairProducts(params);
    };

    handleSearch = (searchTerm) => {
        this.setState({ searchTerm });

        const params = qs.parse(history.location.search.slice(1));
        params.page = '1';

        if (searchTerm) {
            params.s_all = searchTerm;
        } else {
            delete params.s_all;
        }

        history.push({
            ...this.props.location,
            search: qs.stringify(params, QS_OPTIONS),
        });

        this.props.fetchFairProducts(params);
    };

    handleProductTypeSelect = (
        myList,
        { forCart = false, withPromotions = false } = {}
    ) => {
        if (
            this.state.selectedProductType === myList &&
            this.state.prevCart === forCart &&
            this.state.prevPromotions === withPromotions
        ) {
            return;
        }
        this.setState({
            selectedProductType: myList,
            prevCart: forCart,
            prevPromotions: withPromotions,
        });

        const queryParams = qs.parse(history.location.search.slice(1));
        queryParams.mylist = myList;
        if (forCart) {
            queryParams.for_cart = true;
            delete queryParams.with_promotions;
            delete queryParams.filtered;
            delete queryParams.kslist;
            delete queryParams.page;
        } else if (withPromotions) {
            delete queryParams.for_cart;
            queryParams.with_promotions = 1;
            queryParams.page = '1';
        } else {
            delete queryParams.for_cart;
            delete queryParams.with_promotions;
            queryParams.page = '1';
        }

        history.push({
            ...this.props.location,
            search: qs.stringify(queryParams, QS_OPTIONS),
        });

        this.props.fetchFairProducts(queryParams);
    };

    handleProductFilterSelect = (type) => {
        if (type === 'cart') {
            this.handleProductTypeSelect('0', { forCart: true });
            return;
        }

        if (type === 'promotions') {
            this.handleProductTypeSelect('0', { withPromotions: true });
            return;
        }

        if (type === 'all') {
            this.handleProductTypeSelect('0');
            return;
        }

        if (type === 'client') {
            this.handleProductTypeSelect('1');
        }
    };

    getSelectedProductFilter = () => {
        if (this.state.prevCart) {
            return 'cart';
        }

        if (this.state.prevPromotions) {
            return 'promotions';
        }

        return this.state.selectedProductType === '1' ? 'client' : 'all';
    };

    handleDynamicWeeksClick = () => {
        this.setState({
            isDynamicWeeksModalOpen: true,
        });
    };

    closeDynamicWeekModal = () => {
        this.setState({
            isDynamicWeeksModalOpen: false,
        });
    };

    addDynamicWeekHandler = (selectedDynamicWeek) => {
        const yearMonth = selectedDynamicWeek.split('-');

        this.props
            .addFairDynamicWeekPromiseCreator({
                week: yearMonth[1],
                year: yearMonth[0],
            })
            .then(() => {
                const queryParams = qs.parse(history.location.search.slice(1));
                this.props.fetchFairProducts(queryParams);
                this.props.fetchFairDynamicWeeksData();
                this.closeDynamicWeekModal();
            });
    };

    handleToggleColumn = (event) => {
        if (event.target.name !== 'productPhoto') {
            return;
        }

        const showProductPhoto = !this.state.showProductPhoto;
        localStorage.setItem(
            'whatColumnsToShowForFairProducts',
            JSON.stringify([{ id: 'productPhoto', show: showProductPhoto }])
        );
        this.setState({ showProductPhoto });
    };

    downloadPdf = () => {
        const params = qs.parse(history.location.search.slice(1));
        params.mylist = this.state.selectedProductType;

        // Same filters as /fair/product, without pagination
        delete params.page;
        delete params.limit;

        FairService.getPdf(params).then((data) =>
            saveFile(data, `products-list.pdf`)
        );
    };

    handleMailFairCart = () => {
        this.setState({ isMailLoading: true });
        FairService.sendBaskets()
            .then(() => FairService.getFairProductsList())
            .then((response) => {
                this.setState({
                    fairCartProducts: response.data,
                    isMailLoading: false,
                });
                toast.success(
                    <FormattedMessage id="fair.cart_button.mail_success" />
                );
            })
            .catch(() => {
                this.setState({ isMailLoading: false });
            });
    };

    onGroupFilter = (id) => {
        const queryParams = qs.parse(history.location.search.slice(1));
        queryParams.group_id = id;
        this.fetchData(queryParams);

        this.setState({ selectedGroup: id });
    };

    render() {
        const {
            total,
            isLoading,
            suppliers,
            fairPoints,
            data,
            dynamicWeeksData,
            intl,
        } = this.props;

        return (
            <React.Fragment>
                <Fair
                    selectedGroup={this.state.selectedGroup}
                    onGroupFilter={this.onGroupFilter}
                    fairCartProducts={this.state.fairCartProducts}
                    data={data}
                    handleToggleColumn={this.handleToggleColumn}
                    showProductPhoto={this.state.showProductPhoto}
                    selectedProductType={this.getSelectedProductFilter()}
                    selectedSuppliers={this.state.selectedSuppliers}
                    suppliers={suppliers}
                    searchTerm={this.state.searchTerm}
                    handleSelectSuppliers={this.getSelectedSuppliers}
                    handleSearch={this.handleSearch}
                    handleFetchData={this.fetchData}
                    setFairProducts={this.props.setFairProducts}
                    itemsCount={total}
                    isLoading={isLoading}
                    handleProductTypeSelect={this.handleProductFilterSelect}
                    fairPoints={fairPoints}
                    addProduct={this.addProduct}
                    downloadPdf={this.downloadPdf}
                    weekAbbreviation={intl.formatMessage({
                        id: 'fair.week_abbreviation',
                    })}
                    showDynamicWeeksButton={
                        dynamicWeeksData && dynamicWeeksData.totalMaxAmount > 0
                    }
                    disableDynamicWeeksButton={
                        dynamicWeeksData &&
                        dynamicWeeksData.totalMaxAmount <=
                            dynamicWeeksData.userWeeksTotal
                    }
                    handleDynamicWeeksClick={this.handleDynamicWeeksClick}
                    loadingState={this.state.loadingState}
                    onMailFairCart={this.handleMailFairCart}
                    isMailLoading={this.state.isMailLoading}
                />
                <FairDynamicWeeksModalContainer
                    isOpen={this.state.isDynamicWeeksModalOpen}
                    addDynamicWeekHandler={this.addDynamicWeekHandler}
                    closeModal={this.closeDynamicWeekModal}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        filterable: state.table.filterable,
        data: state.fairProducts.data,
        total: state.fairProducts.total,
        isLoading: state.fairProducts.loading,
        suppliers: state.fairSuppliers.data,
        userDetails: state.userDetails.data,
        fairPoints: {
            data: state.fairPoints.data,
            isLoading: state.fairPoints.loading,
        },
        dynamicWeeksData: state.fairDynamicWeeks.data,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators(
            {
                toggleFilterable,
                fetchFairProducts,
                fetchFairSuppliers,
                fetchFairPoints,
                fetchFairDynamicWeeksData,
                setFairProducts,
            },
            dispatch
        ),
        ...bindPromiseCreators(
            {
                addFairDynamicWeekPromiseCreator,
            },
            dispatch
        ),
    };
};

export default injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(FairContainer)
);
